import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import popup from "./slices/popup";
import theme from "./slices/theme";
import friends from "./slices/friends";
import globalLeaderboards from "./slices/globalLeaderboards";
import inventories from "./slices/inventories";
import alert from "./slices/alert";
import inAppNotification from "./slices/inAppNotification";
import { reducer as auth } from "@onmo/auth";
import onboarding from "./slices/onboardingSlice";
import user from "./slices/user";

export const store = configureStore({
  reducer: {
    popup,
    theme,
    friends,
    globalLeaderboards,
    inventories,
    alert,
    inAppNotification,
    auth,
    onboarding,
    user,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export type AsyncAppThunk<ReturnType = Promise<void>> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
